<template>
  <div class='massLoss-list' v-loading='pageLoading'>
    <div class='nav'>
      <el-form :model='searchForm' label-width='110px' :inline='true'
               class='demo-form-inline flex1'>
        <el-form-item label='年份：'>
          <el-date-picker v-model='searchForm.start' type='year' size='mini'
                          style='width:150px' value-format='yyyy' @change='dateChange'
                          placeholder='开始日期' />
          <span style='display:inline-block;width:15px;text-align:center;font-size:18px'>-</span>
          <el-date-picker v-model='searchForm.end' type='year' size='mini'
                          style='width:150px' value-format='yyyy' @change='dateChange'
                          placeholder='结束日期' />
        </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          ref='registerTable'
          row-key='id'
          v-loading='tableLoading'
          :data='tableData'
          max-height='700'
          style='width: 100%'
          border
          :header-cell-style='headerCellStyle'
        >

          <el-table-column label='月度商品车运输量对比表' align='center'>
            <el-table-column prop='name' label='时间' align='center' min-width='100px' />
            <el-table-column prop='january' label='1月' align='center' min-width='100px'
                             :formatter='numberFormat' />
            <el-table-column prop='february' label='2月' align='center' min-width='100px'
                             :formatter='numberFormat' />
            <el-table-column prop='march' label='3月' align='center' min-width='100px'
                             :formatter='numberFormat' />
            <el-table-column prop='april' label='4月' align='center' min-width='100px'
                             :formatter='numberFormat' />
            <el-table-column prop='may' label='5月' align='center' min-width='100px'
                             :formatter='numberFormat' />
            <el-table-column prop='june' label='6月' align='center' min-width='100px'
                             :formatter='numberFormat' />
            <el-table-column prop='july' label='7月' align='center' min-width='100px'
                             :formatter='numberFormat' />
            <el-table-column prop='august' label='8月' align='center' min-width='100px'
                             :formatter='numberFormat' />
            <el-table-column prop='september' label='9月' align='center' min-width='100px'
                             :formatter='numberFormat' />
            <el-table-column prop='october' label='10月' align='center' min-width='100px'
                             :formatter='numberFormat' />
            <el-table-column prop='november' label='11月' align='center' min-width='100px'
                             :formatter='numberFormat' />
            <el-table-column prop='december' label='12月' align='center' min-width='100px'
                             :formatter='numberFormat' />
          </el-table-column>
          <el-table-column label='单位（辆）' align='center'>
            <el-table-column prop='count' label='同期累计' align='center' min-width='100'
                             :formatter='numberFormat' />
            <el-table-column prop='ljtb' label='累计同比' align='center' min-width='100' />
          </el-table-column>
        </el-table>
      </div>
    </div>

    <moth-freight-volume-echart ref='mothFreightVolumeEchartRef'
                                @pageLoadingChange='pageLoadingChange' />
  </div>
</template>

<script>
  import { translationAnalysisEchart, translationAnalysisList } from '@/service/financial';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import MothFreightVolumeEchart from './components/mothFreightVolumeEchart.vue';

  export default {
    name: 'mothFreightVolumeReport',
    components: { MothFreightVolumeEchart },
    data() {
      return {
        searchForm: {
          start: '',
          end: '',
        },
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        pageLoading: false,
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
      };
    },
    mounted() {
      this.getDefaultYear();
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      this.searchBtn();
    },
    methods: {
      numberFormat(row, column, cellValue) {
        let str = cellValue.toString();
        let reverse_str = str.split('')
          .reverse()
          .join('');
        let arr = [];
        for (let i in reverse_str) {
          if (i % 3 === 0) {
            arr.push(reverse_str.substr(i, 3)
              .split('')
              .reverse()
              .join(''));
          }
        }
        return arr.reverse()
          .join(',');
      },
      // 结束时间
      dateChange(val) {
        if (this.searchForm.end && this.searchForm.start && (this.searchForm.end < this.searchForm.start)) {
          if (val === this.searchForm.end) this.searchForm.end = '';
          if (val === this.searchForm.start) this.searchForm.start = '';
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      // 导出数据
      exportData() {
        this.pageLoading = true;
        let token = getSessionStore('token');
        const url = `${baseUrl}/platform/translationAnalysis/export?access_token=${token}`;
        this.$refs.mothFreightVolumeEchartRef.exportData(url, this.searchForm);
      },
      // 查询
      searchBtn() {
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      // 获取表格数据
      async getTableData() {
        if (this.searchForm.start === null || this.searchForm.end === null) return this.$message.warning('请选择时间后查询！');
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await translationAnalysisList(this.searchForm);
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data;
        await this.getEcharts();
      },
      async getEcharts() {
        const {
          status,
          message,
          data,
        } = await translationAnalysisEchart(this.searchForm);
        if (status !== 0) return this.$message.warning(message);
        this.$refs.mothFreightVolumeEchartRef.init(data);
      },
      getDefaultYear() {
        const date = new Date();
        this.searchForm.end = date.getFullYear()
          .toString();
        this.searchForm.start = (date.getFullYear() - 2).toString();
      },
      pageLoadingChange(flag) {
        this.pageLoading = flag;
      },
    },
  };
</script>


<style lang='scss' scoped>
  .massLoss-list {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    ::v-deep .detail {
      .el-form-item {
        margin-bottom: 2px;

        .el-form-item__label {
          /*color: #060606;*/
          font-weight: 700;
        }
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }


        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }


    ::v-deep .add {
      .el-form-item__label {
        font-weight: 700;
      }

      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .yang {
            .el-form-item {
              .el-form-item__error {
                left: 40px;
              }

              margin-bottom: 5px;

              .el-form-item__label {
                // width: 150px !important;
                /*color: #060606;*/
              }

            }

          }

          .repair {
            .el-input {
              width: 80%;
            }

            .el-form-item {
              .el-form-item__error {
                /*left: 41px;*/
                padding-top: 0px;
              }

              margin-bottom: 7px;

              .el-form-item__label {
                /*width: 155px  !important;*/
                /*color: #060606;*/
              }
            }

            .el-upload-list__item {
              width: 100px;
              height: 100px;
            }

            .el-upload--picture-card {
              width: 100px;
              height: 100px;
              line-height: 100px;
            }

            /*display: none;*/
            .imgUp {
              display: flex;
              flex-direction: column;

              .imgLength {
                display: flex;
                align-items: center;
                width: 100%;

                span {
                  margin-left: auto;
                  color: rgb(183, 183, 183);
                  font-size: 16px;
                }
              }
            }
          }

        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

      .el-form--inline .el-form-item {
        margin-bottom: 5px;
      }

    }

  }

  .tableContainer {
    margin: 10px 0 30px 0;
  }

  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      margin-right: 10px;
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
